import React, { useState } from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

import Section from "../Section/edit";
export default (props) => {
  return <Section label={"Header"} {...props} />;
};
